const SET_INITIALIZED = 'settings/SET_INITIALIZED'
const SET_SETTINGS = 'settings/SET_SETTINGS'

const initialState = {
  initialized: false,
  savedExchanges: [],
  savedPairs: [],
}

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INITIALIZED: {
      return {
        ...state,
        initialized: action.initialized,
      }
    }
    case SET_SETTINGS: {
      return {
        ...state,
        savedExchanges: action.savedExchanges,
        savedPairs: action.savedPairs,
      }
    }
    default:
      return state
  }
}

export default settingsReducer

export const settingsActions = {
  setInitialized: (initialized) => ({ type: SET_INITIALIZED, initialized }),
  setSettings: (savedExchanges = [], savedPairs = []) => ({
    type: SET_SETTINGS,
    savedExchanges,
    savedPairs,
  }),
}
